import { http, HttpResponse } from 'msw';
import { AccountApiPaths } from '../../../slices/account-api.slice';
import { activeSessionHandlers } from './active-sessions';
import { authHandlers } from './login';
import { accountHandlers } from './account';
import { enrollmentHandlers } from './enrollment';
import { sessionHandlers } from './session';
import { applicationHandlers } from './applications';
import { ssoHandlers } from './sso';
import { gdprDeleteHandlers } from './gdpr';
import { changePasswordHandlers } from './change-password';
import { aliasHandlers } from './alias';
import { phoneHandlers } from './phone';
import { resetPasswordHandlers } from './reset-password';
import { changeAuthenticatorHandlers } from './change-authenticator';
import { loggingHandlers } from './logging';
import { locale } from './locale';
import { userSettingsHandlers } from './user-settings';
import { apiUrl } from '../apiUrl';

export const signOutUserMutation = http.post(apiUrl(AccountApiPaths.signOutUser), () => {
    return new HttpResponse();
});

// The mock apis defined in this array of handlers are global defaults and msw will use them during test runs.
// Tests can override these defaults with server.use()
// For examples of this see registration-steps.test.tsx

export const handlers = [
    signOutUserMutation,
    ...sessionHandlers,
    ...enrollmentHandlers,
    ...authHandlers,
    ...userSettingsHandlers,
    ...locale,
    ...loggingHandlers,
    ...activeSessionHandlers,
    ...changeAuthenticatorHandlers,
    ...resetPasswordHandlers,
    ...ssoHandlers,
    ...applicationHandlers,
    ...aliasHandlers,
    ...phoneHandlers,
    ...gdprDeleteHandlers,
    ...changePasswordHandlers,
    ...accountHandlers
];
